/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Connections,
  ModelConfiguration,
  QueueReports,
} from '../models/index';
import {
    ConnectionsFromJSON,
    ConnectionsToJSON,
    ModelConfigurationFromJSON,
    ModelConfigurationToJSON,
    QueueReportsFromJSON,
    QueueReportsToJSON,
} from '../models/index';

export interface DeleteJobRequest {
    jobid: string;
}

export interface GetConfigurationRequest {
    institution: string;
}

export interface GetFailedConnectionsRequest {
    institution: string;
}

export interface GetReportsRequest {
    institution: string;
}

export interface GetSucceededConnectionsRequest {
    institution: string;
}

export interface RequeueJobRequest {
    jobid: string;
}

/**
 * 
 */
export class AdminApi extends runtime.BaseAPI {

    /**
     * Creates request options for deleteJob without sending the request
     */
    async deleteJobRequestOpts(requestParameters: DeleteJobRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['jobid'] == null) {
            throw new runtime.RequiredError(
                'jobid',
                'Required parameter "jobid" was null or undefined when calling deleteJob().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/orcid/admin/sync/report/{jobid}`;
        urlPath = urlPath.replace(`{${"jobid"}}`, encodeURIComponent(String(requestParameters['jobid'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete a sync job.
     */
    async deleteJobRaw(requestParameters: DeleteJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteJobRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a sync job.
     */
    async deleteJob(requestParameters: DeleteJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteJobRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getConfiguration without sending the request
     */
    async getConfigurationRequestOpts(requestParameters: GetConfigurationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['institution'] == null) {
            throw new runtime.RequiredError(
                'institution',
                'Required parameter "institution" was null or undefined when calling getConfiguration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/orcid/admin/config/{institution}`;
        urlPath = urlPath.replace(`{${"institution"}}`, encodeURIComponent(String(requestParameters['institution'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get all currently ORCID-connected researchers and their scopes.
     */
    async getConfigurationRaw(requestParameters: GetConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ModelConfiguration>> {
        const requestOptions = await this.getConfigurationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ModelConfigurationFromJSON(jsonValue));
    }

    /**
     * Get all currently ORCID-connected researchers and their scopes.
     */
    async getConfiguration(requestParameters: GetConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ModelConfiguration> {
        const response = await this.getConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getFailedConnections without sending the request
     */
    async getFailedConnectionsRequestOpts(requestParameters: GetFailedConnectionsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['institution'] == null) {
            throw new runtime.RequiredError(
                'institution',
                'Required parameter "institution" was null or undefined when calling getFailedConnections().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/orcid/admin/connect/failed/{institution}`;
        urlPath = urlPath.replace(`{${"institution"}}`, encodeURIComponent(String(requestParameters['institution'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get all researchers which have currently revoked their tokens.
     */
    async getFailedConnectionsRaw(requestParameters: GetFailedConnectionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Connections>> {
        const requestOptions = await this.getFailedConnectionsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConnectionsFromJSON(jsonValue));
    }

    /**
     * Get all researchers which have currently revoked their tokens.
     */
    async getFailedConnections(requestParameters: GetFailedConnectionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Connections> {
        const response = await this.getFailedConnectionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getReports without sending the request
     */
    async getReportsRequestOpts(requestParameters: GetReportsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['institution'] == null) {
            throw new runtime.RequiredError(
                'institution',
                'Required parameter "institution" was null or undefined when calling getReports().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/orcid/admin/sync/reports/{institution}`;
        urlPath = urlPath.replace(`{${"institution"}}`, encodeURIComponent(String(requestParameters['institution'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get all currently store sync job reports.
     */
    async getReportsRaw(requestParameters: GetReportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QueueReports>> {
        const requestOptions = await this.getReportsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QueueReportsFromJSON(jsonValue));
    }

    /**
     * Get all currently store sync job reports.
     */
    async getReports(requestParameters: GetReportsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QueueReports> {
        const response = await this.getReportsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getSucceededConnections without sending the request
     */
    async getSucceededConnectionsRequestOpts(requestParameters: GetSucceededConnectionsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['institution'] == null) {
            throw new runtime.RequiredError(
                'institution',
                'Required parameter "institution" was null or undefined when calling getSucceededConnections().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/orcid/admin/connect/success/{institution}`;
        urlPath = urlPath.replace(`{${"institution"}}`, encodeURIComponent(String(requestParameters['institution'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get all currently ORCID-connected researchers and their scopes.
     */
    async getSucceededConnectionsRaw(requestParameters: GetSucceededConnectionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Connections>> {
        const requestOptions = await this.getSucceededConnectionsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConnectionsFromJSON(jsonValue));
    }

    /**
     * Get all currently ORCID-connected researchers and their scopes.
     */
    async getSucceededConnections(requestParameters: GetSucceededConnectionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Connections> {
        const response = await this.getSucceededConnectionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for requeueJob without sending the request
     */
    async requeueJobRequestOpts(requestParameters: RequeueJobRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['jobid'] == null) {
            throw new runtime.RequiredError(
                'jobid',
                'Required parameter "jobid" was null or undefined when calling requeueJob().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }


        let urlPath = `/orcid/admin/sync/requeue/{jobid}`;
        urlPath = urlPath.replace(`{${"jobid"}}`, encodeURIComponent(String(requestParameters['jobid'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Requeue a sync job.
     */
    async requeueJobRaw(requestParameters: RequeueJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.requeueJobRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Requeue a sync job.
     */
    async requeueJob(requestParameters: RequeueJobRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.requeueJobRaw(requestParameters, initOverrides);
    }

}
